// @flow
import { handleResponseOld, makeGet, makePost } from './helpers';

const transformSellerRating = payload => {
    const rating = payload.payload;
    return {
        [rating.houseId]: rating,
    };
};

const transformHelpfulCount = body => {
    if (Array.isArray(body.payload)) {
        const val = body.payload.map(item => {
            return { [item.reviewId]: item.count };
        });
        return Object.assign({}, ...val);
    }
};

const transformReviewComments = body => {
    if (body.payload && Boolean(body.payload.length)) {
        const arr = { [body.payload[0].houseId]: body.payload };
        return arr;
    } else return [];
};

const transformBidderStatuses = body => {
    if (Array.isArray(body.payload)) {
        const val = body.payload.map(item => {
            return { [item.reviewId]: item.flags };
        });
        return Object.assign({}, ...val);
    }
};

type FetchBidderStatusesParams = {
    authToken: string,
    deployment: string,
    reviewIds: any,
};

type FetchHelpfulCountsParams = {
    authToken?: string,
    deployment: string,
    reviewIds: any,
};

type FetchHouseCommentsParams = {
    authToken: string,
    deployment: string,
    houseId: number,
};

type FetchHouseReviewDataParams = {
    authToken: string,
    deployment: string,
    filter: string,
    houseId: number,
    page: number,
    pageSize: number,
    sort: string,
};

type FetchHousePercentilesParams = {
    authToken: string,
    deployment: string,
    houseId: number,
};

type FetchReviewCommentsParams = {
    authToken: string,
    deployment: string,
    reviewId: any,
};

type FetchReviewDataParams = {
    authToken: string,
    bidderId: number,
    catalogIds: any,
    deployment: string,
};

type SetReviewStatusParams = {
    authToken: string,
    deployment: string,
    reviewStatus: any,
};

type SubmitReviewParams = {
    authToken: string,
    deployment: string,
    review: any,
};

export default {
    fetchBidderStatuses: ({ authToken, reviewIds, deployment }: FetchBidderStatusesParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makeGet({
                apiPath: 'getbidderreviewstatus',
                authToken,
                deployment,
                path: '<REVIEW-API>',
            });
            const ids = `[${reviewIds.join(',')}]`;
            request.query({ reviewIds: ids });
            request.end((err, response) =>
                handleResponseOld({ err, reject, resolve, response, transform: transformBidderStatuses })
            );
        }),
    fetchHelpfulCounts: ({ reviewIds, deployment }: FetchHelpfulCountsParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makeGet({
                apiPath: 'gethelpfulcount',
                deployment,
                path: '<REVIEW-API>',
            });
            const ids = `[${reviewIds.join(',')}]`;
            request.query({ reviewIds: ids });
            request.end((err, response) =>
                handleResponseOld({ err, reject, resolve, response, transform: transformHelpfulCount })
            );
        }),
    fetchHouseComments: ({ authToken, deployment, houseId }: FetchHouseCommentsParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makeGet({
                apiPath: 'GetHouseReviewComments',
                authToken,
                deployment,
                path: '<REVIEW-API>',
            });
            request.query({ houseId, publicOnly: true });
            request.end((err, response) =>
                handleResponseOld({ err, reject, resolve, response, transform: transformReviewComments })
            );
        }),
    fetchHousePercentiles: ({ authToken, deployment, houseId }: FetchHousePercentilesParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makeGet({
                apiPath: 'rank',
                authToken,
                deployment,
                path: '<REVIEW-API>',
            });
            request.query({ houseId });
            request.end((err, response) =>
                handleResponseOld({ err, reject, resolve, response, transform: transformSellerRating })
            );
        }),
    fetchHouseReviewData: ({
        authToken,
        deployment,
        filter = '',
        houseId,
        page = 1,
        pageSize = 50,
        sort = '-overall',
    }: FetchHouseReviewDataParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makeGet({
                apiPath: 'rating',
                authToken,
                deployment,
                path: '<REVIEW-API>',
            });

            request.query({ filter, houseId, page, pageSize, sort });
            request.end((err, response) =>
                handleResponseOld({ err, reject, resolve, response, transform: transformSellerRating })
            );
        }),
    fetchReviewComments: ({ authToken, deployment, reviewId }: FetchReviewCommentsParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makeGet({
                apiPath: 'GetHouseReviewComments',
                authToken,
                deployment,
                path: '<REVIEW-API>',
            });
            request.query({ reviewId });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
    fetchReviewData: ({ authToken, bidderId, catalogIds, deployment }: FetchReviewDataParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makeGet({
                apiPath: 'GetReviewInformation',
                authToken,
                deployment,
                path: '<REVIEW-API>',
            });
            request.query({ bidderId, catalogs: `${catalogIds}` });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
    setBidderReviewStatus: ({ authToken, deployment, reviewStatus }: SetReviewStatusParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makePost({ apiPath: 'setreviewstatus', authToken, deployment, path: '<REVIEW-API>' });
            request.send(reviewStatus);
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
    submitReview: ({ authToken, deployment, review }: SubmitReviewParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makePost({
                apiPath: 'createreview',
                authToken,
                deployment,
                path: '<REVIEW-API>',
            });
            request.send(review);
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
};
